import React from "react";
import { Loader2 } from "lucide-react";

const LoaderOverlay: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <Loader2 className="w-12 h-12 text-blue-700 animate-spin" />
    </div>
  );
};

export default LoaderOverlay;
